//function to convert a timestamp that we get from database into a displayable date format
export function formatDate(date){
    var tempDate = new Date(date);
    return (            
        tempDate.toLocaleDateString("en-AU").replace(/[\u200E]/g, '') //to fix the additional spacing issue when downloaded from IE
    )
}

// format the date using the parts making up the date
// this is essentially the ISO 8601 format without the timezone so it will work with model binding
// build up using the parts so no conversion to utc happens and is cross browser compatible
export function formatDatetimeLocal(date) {
    var
      ten = function (i) {
        return (i < 10 ? '0' : '') + i;
      },
      YYYY = date.getFullYear(),
      MM = ten(date.getMonth() + 1),
      DD = ten(date.getDate()),
      HH = ten(date.getHours()),
      II = ten(date.getMinutes()),
      SS = ten(date.getSeconds())
    ;
    return YYYY + '-' + MM + '-' + DD + 'T' +
              HH + ':' + II + ':' + SS;
  }

//function to convert a timestamp that we get from database into a displayable datetime format
export function formatDateTime(datetime){
    var tempDate = new Date(datetime);
    return (            
        tempDate.toLocaleDateString("en-AU") + " " + tempDate.toLocaleTimeString()
    )
}

export function formatCurrency(amount) {
    if(isNaN(amount)){
        return(
            new Intl.NumberFormat('en-AU', { 
                style: 'currency', 
                currency: 'AUD' 
            }).format(0.00)
        )

    }
    return(
        new Intl.NumberFormat('en-AU', { 
            style: 'currency', 
            currency: 'AUD' 
        }).format(amount)
    )
}

/*for tables start*/
export function formatTableCurrency(cell, row) {
    return (
        formatCurrency(cell)
    );
}

export function formatTableDate(cell, row){
    return (
        formatDate(cell)
    );
}

export function formatTableDateTime(cell, row){              
    return (
        formatDateTime(cell)
    );
}
/*for tables end*/


// WEBPACK FOOTER //
// ./src/js/utils.js